import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { CodeSentryFetcherName } from '../../../../../../../shared/fetchers';
import Locator from '../../../../../../../shared/Locator';
import { useGetDependencyConfidence } from '../../../../../../hooks/api';
import * as DependenciesV2Store from '../../../../../../redux/dependenciesV2';
import List from '../../../../../generic/List';
import BinaryComponentBadge from '../../../../../shared/revisions/BinaryComponentBadge';
import type { Dependency } from '../../../../../../../shared/dependenciesV2';

import LicensingSection from './LicensingSection';

type Props = {
  // Dependency data from API response
  dependency: Dependency;
};

/**
 * Displays issue and license details for a dependency
 */
const DetailsRow: VoidFunctionComponent<Props> = ({ dependency }) => {
  const scope = useSelector(DependenciesV2Store.selectors.getScope);
  const projectRevision = scope && scope.scope === 'project' ? scope.revision : '';
  const { confidence, isLoading } = useGetDependencyConfidence(projectRevision, dependency.locator);
  const dependencyLocator = Locator.parse(dependency.locator);
  const isBinaryComponent = dependencyLocator.fetcher === CodeSentryFetcherName;

  return (
    <List.RowDetails>
      { isBinaryComponent && (
        <BinaryComponentBadge confidence={confidence} isLoading={isLoading} />
      )}
      <LicensingSection
        licenses={dependency.licenses}
        declaredLicenses={dependency.declaredLicenses}
        issues={dependency.issues}
      />
    </List.RowDetails>
  );
};

export default DetailsRow;
